/* Somavie advertorial clone — interactivity (evergreen countdown, CTA scroll, hero FAQ) */
(function(){
  "use strict";
  var WINDOW_MS = 8*60*60*1000; // evergreen 8h rolling deal

  function pad(n){return (n<10?"0":"")+n;}
  function target(){
    var t = parseInt(localStorage.getItem("som_deal_end")||"0",10);
    var now = Date.now();
    if(!t || t < now){ t = now + WINDOW_MS; localStorage.setItem("som_deal_end", String(t)); }
    return t;
  }
  function tick(){
    var els = document.querySelectorAll(".som-cd");
    if(!els.length) return;
    var diff = Math.max(0, target()-Date.now());
    var s = Math.floor(diff/1000);
    var h = Math.floor(s/3600), m = Math.floor((s%3600)/60), ss = s%60;
    var txt = pad(h)+":"+pad(m)+":"+pad(ss);
    for(var i=0;i<els.length;i++){ els[i].textContent = txt; }
  }

  function buyBox(){
    return document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('.product-form, product-form, .shopify-payment-button')
        || document.querySelector('main [id*="MainProduct"], #MainContent');
  }
  function onCta(e){
    var t = e.target.closest('.som-cta, .cta_btn, .som-order-cta, .rv_show-btn');
    if(!t) return;
    var bx = buyBox();
    e.preventDefault();
    if(t.classList.contains('rv_show-btn')) return; // decorative
    if(bx){
      var y = bx.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({top:Math.max(0,y), behavior:"smooth"});
    } else {
      window.scrollTo({top:0, behavior:"smooth"});
    }
  }

  function onFaq(e){
    var q = e.target.closest('.faq_question');
    if(!q) return;
    var ans = q.nextElementSibling;
    while(ans && !ans.classList.contains('faq_answer')) ans = ans.nextElementSibling;
    if(!ans) return;
    var open = ans.getAttribute('data-open')==='1';
    if(open){ ans.style.maxHeight='0px'; ans.setAttribute('data-open','0'); }
    else{ ans.style.maxHeight = (ans.scrollHeight+40)+'px'; ans.setAttribute('data-open','1'); }
    var pm = q.querySelector('.p-m-wrap');
    if(pm) pm.classList.toggle('is-open', !open);
  }

  var timer=null;
  function init(){
    tick();
    if(timer) clearInterval(timer);
    timer = setInterval(tick, 1000);
  }
  document.addEventListener('click', onCta, true);
  document.addEventListener('click', onFaq, false);
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
